var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
/**
 * A single free slot offered to a patient (PRD #1343, RS-001). This is the
 * redacted projection of the internal `SlotDto`: it exposes ONLY the start
 * time, the duration, and the therapist's display name. Rooms, devices,
 * internal therapist ids, week metadata and every other scheduling internal
 * are deliberately absent — a patient must never see calendar internals or
 * other patients' data (PRD user story 38). A unit test asserts this absence.
 *
 * `therapistName` is null under an "egal" search (RS-007): slots are then
 * time-deduped across all therapists, so no single name applies.
 */
export class PatientBookingSlotDto {
    start;
    durationMin;
    therapistName;
}
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Date)
], PatientBookingSlotDto.prototype, "start", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientBookingSlotDto.prototype, "durationMin", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientBookingSlotDto.prototype, "therapistName", void 0);
//# sourceMappingURL=patient-booking-slot.dto.js.map